const formatNumber = (number) => {
    const numString = String(number);
    const numArray = numString.split('');
    const resultArray = [];
    for (let i = 0; i < numArray.length; i++) {
      // 8자리마다 '억' 추가
        if (i > 0 && i % 8 === 0) {
            resultArray.unshift('억 ');
        }
  
      // 4자리마다 '만' 추가
        if (i > 0 && i % 4 === 0 && i % 8 !== 0) {
            resultArray.unshift('만 ');
        }
      resultArray.unshift(numArray[numArray.length - 1 - i]);
    }
    return resultArray.join('');
};

export default formatNumber;